import ga4 from "@/lib/tracking/ga4Core";

const ADD_SERVICE_JOURNEY = "add_service";
export const ADD_SERVICE_TARGETS = {
  PROPERTY_LISTING_BY_BROKER: "property_listing_by_broker",
  PROPERTY_LISTING_BY_OWNER: "property_listing_by_owner/agent",
  BOOKABLE_UNIT: "bookable_unit",
  MARKETING_REQUEST: "property_marketing_request",
  SEARCH_REQUEST: "property_search_request",
};
const SOURCE_KEY = "add_service_source";

const storeSource = (source) => {
  localStorage.setItem(SOURCE_KEY, source);
};

const getSource = () => {
  const source = localStorage.getItem(SOURCE_KEY);
  if (typeof source === "string") {
    return source;
  }
  return null;
};

export const trackSelectServiceOption = ({
  source = "add_new_listing",
  target,
}) => {
  const eventName = "click_interaction";
  const eventParams = {
    target,
    source,
    journey_details: ADD_SERVICE_JOURNEY,
  };

  storeSource(target);

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackContinueServiceOption = () => {
  const eventName = "click_interaction";
  const eventParams = {
    target: "continue",
    source: ADD_SERVICE_TARGETS.PROPERTY_LISTING_BY_OWNER,
    journey_details: ADD_SERVICE_JOURNEY,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackSubscribeFromServiceOption = () => {
  const eventName = "click_interaction";
  const eventParams = {
    target: "subscribe_to_package",
    source: ADD_SERVICE_TARGETS.PROPERTY_LISTING_BY_OWNER,
    journey_details: ADD_SERVICE_JOURNEY,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackAddListingNext = () => {
  const source = getSource();
  const eventName = "click_interaction";
  const eventParams = {
    target: "next",
    source,
    journey_details: ADD_SERVICE_JOURNEY,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackAddListingCompleteLater = () => {
  const source = getSource();
  const eventName = "click_interaction";
  const eventParams = {
    target: "complete_later",
    source,
    journey_details: ADD_SERVICE_JOURNEY,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackPublishAd = () => {
  const source = getSource();
  const eventName = "click_interaction";
  const eventParams = {
    target: "publish_ad",
    source,
    journey_details: ADD_SERVICE_JOURNEY,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackEditAd = () => {
  const source = getSource();
  const eventName = "click_interaction";
  const eventParams = {
    target: "edit_ad",
    source,
    journey_details: ADD_SERVICE_JOURNEY,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackSubmitSearchRequest = () => {
  const eventName = "click_interaction";
  const eventParams = {
    target: "submit",
    source: ADD_SERVICE_TARGETS.SEARCH_REQUEST,
    journey_details: ADD_SERVICE_JOURNEY,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackAddServiceError = ({
  errorMessage,
  errorCode,
  errorType,
  fieldName,
}) => {
  const source = getSource();
  const eventName = "error_occurred";
  const eventParams = {
    error_message: errorMessage,
    error_code: errorCode,
    error_type: errorType,
    field_name: fieldName,
    source,
    journey_details: ADD_SERVICE_JOURNEY,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackAddServiceErrors = (errors) => {
  if (errors && Object.keys(errors).length > 0) {
    Object.entries(errors).forEach(([fieldName, error]) => {
      trackAddServiceError({
        errorMessage: error,
        errorCode: fieldName,
        errorType: "validation_error",
        fieldName,
      });
    });
  }
};

export const trackAddServiceAlert = ({ alertMessage }) => {
  const source = getSource();
  const eventName = "alert";
  const eventParams = {
    alert_message: alertMessage,
    source,
    journey_details: ADD_SERVICE_JOURNEY,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackAdLicenseCheck = ({ target }) => {
  const eventName = "ad_license_check";
  const eventParams = {
    target,
    source: "property_listing_by_broker",
    journey_details: ADD_SERVICE_JOURNEY,
  };

  ga4.trackUserInteraction(eventName, eventParams);
}

export const trackAdLicenseContinue = ({ inputData }) => {
  const eventName = "ad_license_continue";
  const eventParams = {
    target: "continue",
    source: "property_listing_by_broker",
    journey_details: ADD_SERVICE_JOURNEY,
    input_data: inputData
  };

  ga4.trackUserInteraction(eventName, eventParams);
}

export const trackIssueAdLicense = ({}) => {
  const eventName = "issue_ad_license";
  const eventParams = {
    target: "continue",
    source: "property_listing_by_broker",
    journey_details: ADD_SERVICE_JOURNEY
  };

  ga4.trackUserInteraction(eventName, eventParams);
}

export const trackAdLicenseSuccess = ({}) => {
  const eventName = "issue_ad_license_success";
  const eventParams = {
    target: "ad_license_success",
    source: "property_listing_by_broker",
    journey_details: ADD_SERVICE_JOURNEY,
  }

  ga4.trackUserInteraction(eventName, eventParams);
}
